import { render } from "./AsOrder.vue?vue&type=template&id=71b7ff6a"
import script from "./AsOrder.vue?vue&type=script&lang=js"
export * from "./AsOrder.vue?vue&type=script&lang=js"

import "./AsOrder.vue?vue&type=style&index=0&id=71b7ff6a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__